import { styled } from '@mui/material/styles';

export const MailContainer = styled('div',
  { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      flexGrow: 1,
      overflow: 'hidden',
      [theme.breakpoints.up('md')]: {
        marginLeft: -280
      },
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      ...(open && {
        [theme.breakpoints.up('md')]: {
          marginLeft: 0
        },
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen
        })
      })
    }));
